import { Autocomplete, TextField } from "@mui/material";
import { Button } from "@mui/material";
import { BiPlus } from "react-icons/bi";
import "./searchOrAdd.css";

export function SearchOrAdd({
  givenOptions = [],
  label,
  multiple = false,
  addForm: AddForm,
  hasAddForm,
  value,
  onChange,
  getOptionLabel,
  isCreationDialogueOpen,
  setIsCreationDialogueOpen,
  isOptionEqualToValue,
}) {
  const handleShowDialogue = () => {
    setIsCreationDialogueOpen(!isCreationDialogueOpen);
  };

  return (
    <div className="search_or_add">
      {isCreationDialogueOpen && AddForm}
      <Autocomplete
        multiple={multiple}
        value={value}
        className="autocomplete"
        options={
          givenOptions.length > 0 ? givenOptions : ["Cargando opciones..."]
        }
        renderInput={(params) => <TextField {...params} label={label} />}
        getOptionLabel={getOptionLabel}
        onChange={onChange}
        isOptionEqualToValue={isOptionEqualToValue}
      />
      {hasAddForm && (
        <Button
          variant="outlined"
          color="secondary"
          size="small"
          className="add_button"
          sx={{ width: 20 }}
          onClick={handleShowDialogue}
        >
          <BiPlus />
        </Button>
      )}
    </div>
  );
}
